var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bgimg-1, .bgimg-2, .bgimg-3 {\r\n  position: relative;\r\n  background-attachment: fixed;\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n  background-size: cover;\r\n}\r\n.bgimg-1 {\r\n  background-image: url(" + escape(require("../../assets/images/img_parallax.png")) + ");\r\n  min-height: 100%;\r\n}\r\n\r\n.caption {\r\n  position: absolute;\r\n  left: 0;\r\n  top: 50%;\r\n  width: 100%;\r\n  text-align: center;\r\n  color: white;\r\n}\r\n\r\n.projectGit{\r\n  color: white;\r\n  font-size: 36px;\r\n}\r\n\r\n.projectGit:hover {\r\n  color:darkgray;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/benge/Angular/my-first-app/src/app/resume-page/resume-page.component.css
// module id = ../../../../../src/app/resume-page/resume-page.component.css
// module chunks = main